// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyLoad from 'vue-lazyload'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

Vue.config.productionTip = false
Vue.use(VueLazyLoad)
Vue.use(firestorePlugin)
Vue.use(firebase)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// Initialize Firebase
var firebaseConfig = {
  apiKey: 'AIzaSyD3xmcuBqxhuseazrKi0JyOIbcKEugjxMA',
  authDomain: 'keeploling-website.firebaseapp.com',
  databaseURL: 'https://keeploling-website.firebaseio.com',
  projectId: 'keeploling-website',
  storageBucket: 'keeploling-website.appspot.com',
  messagingSenderId: '577690624452',
  appId: '1:577690624452:web:729e6f894df406a80d8491',
  measurementId: 'G-N3TKNWQQ1K'
}

firebase.initializeApp(firebaseConfig)



// WEBPACK FOOTER //
// ./src/main.js